import { createApp } from "vue";
import App from "./App.vue";

import Vue3SocialSharingPlugin from "vue3-social-sharing";
import GsapPlugin from "./plugins/gsap";

let app = null;

import "aos/dist/aos.css";
import "./assets/main.css";
function mount(rootComponent) {
  app = createApp(App);
  app.use(Vue3SocialSharingPlugin);
  app.use(GsapPlugin);
  app.mount(rootComponent);
}
/*
if (process.env.NODE_ENV === "development") {
  mount("#app");
}*/
mount("#app");
export default {
  init(rootComponent) {
    if (!app) {
      mount(rootComponent);
    }
  },
};
// import { createApp } from "vue";
// import App from "./App.vue";

// let app = null;

// function mount(rootComponent) {
//   console.log("Mounting Vue app...");
//   app = createApp(App);
//   app.mount(rootComponent);
//   console.log("Vue app mounted.");
// }

// if (process.env.NODE_ENV === "development") {
//   mount("#app");
// }

// export default {
//   init(rootComponent) {
//     console.log("Initializing Vue app...");
//     if (!app) {
//       mount(rootComponent);
//     }
//     console.log("Vue app initialized.");
//   },
// };
